import React, { useState } from 'react';
import FeedbackListSubTab from './FeedbackListSubTab';
import BlogPostsSubTab from './BlogPostsSubTab';
import './FeedbackTab.css';

function FeedbackTab() {
  const [activeSubTab, setActiveSubTab] = useState('feedback');

  return (
    <div className="feedback-tab">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'feedback' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('feedback')}
        >
          Обратная связь
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'articles' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('articles')}
        >
          Статьи
        </button>
      </div>
      <div className="sub-tab-content">
        {activeSubTab === 'feedback' && <FeedbackListSubTab />}
        {activeSubTab === 'articles' && <BlogPostsSubTab />}
      </div>
    </div>
  );
}

export default FeedbackTab;

